import { render, staticRenderFns } from "./HelperTextPopup.vue?vue&type=template&id=5a666e4e&"
import script from "./HelperTextPopup.vue?vue&type=script&setup=true&lang=js&"
export * from "./HelperTextPopup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a666e4e')) {
      api.createRecord('5a666e4e', component.options)
    } else {
      api.reload('5a666e4e', component.options)
    }
    module.hot.accept("./HelperTextPopup.vue?vue&type=template&id=5a666e4e&", function () {
      api.rerender('5a666e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/HelperTextPopup.vue"
export default component.exports